import { defineComponent as _defineComponent } from 'vue'
import { toRefs } from '@nuxtjs/composition-api';

interface Props {
    duration?: string,
    width?: string,
    height?: string,
    isXmasMode?: boolean,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Affility',
  props: {
    duration: { default: '1.5s' },
    width: { default: '40px' },
    height: { default: '40px' },
    isXmasMode: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { duration: string, width: string, height: string, isXmasMode: boolean };


const {
    duration,
    width,
    height,
    isXmasMode,
} = toRefs(props);

return { __sfc: true,props, duration, width, height, isXmasMode }
}

})